webpackJsonp([10045839604240],{

/***/ 747:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactHelmet = __webpack_require__(7);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _config = __webpack_require__(8);
	
	var _Fleet = __webpack_require__(20);
	
	var _Fleet2 = _interopRequireDefault(_Fleet);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PremiumEliteEs = function PremiumEliteEs(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'page Premium' },
	    _react2.default.createElement(_reactHelmet2.default, {
	      title: 'Veh\xEDculos Premiumos para alquilar | Budget Nicaragua',
	      meta: [{
	        name: 'description',
	        content: 'Preguntas frecuentes sobre el alquiler de autos.'
	      }],
	      link: [{
	        rel: 'alternate',
	        hreflang: 'es',
	        href: './en/fleet/premium_elite'
	      }]
	    }),
	    _react2.default.createElement(
	      'h1',
	      null,
	      'Premium Elite'
	    ),
	    _react2.default.createElement(_Fleet2.default, {
	      lang: props.pathContext.langKey,
	      types: props.data.dataJson.fleetTypes,
	      fleet: props.data.dataJson.fleet,
	      features: props.data.dataJson.fleetFeatures,
	      category: 8
	    })
	  );
	};
	
	//Components
	var query = exports.query = '** extracted graphql fragment **';
	
	exports.default = PremiumEliteEs;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-fleet-premium-elite-es-js-dcdc1c588de53258c1b6.js